export default "__VITE_ASSET__7bqcK24i__"